// frontend/src/pages/PrivacyPolicyPage.js
import React, { useState, useEffect } from 'react';
import { settingsApi } from '../api/settings';
import { FaShieldAlt, FaSpinner } from 'react-icons/fa';
import ReactMarkdown from 'react-markdown';

function PrivacyPolicyPage() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const data = await settingsApi.getAllSettings();
        if (data && data.pages_content && data.pages_content.privacy_policy) {
          setContent(data.pages_content.privacy_policy);
        }
      } catch (err) {
        console.error("Failed to load privacy policy", err);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  return (
    <div className="bg-white py-12 md:py-20 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <FaShieldAlt className="text-5xl text-primary mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-gray-800">Privacy Policy</h1>
        </div>

        {loading ? (
          <div className="flex justify-center py-10">
            <FaSpinner className="animate-spin text-3xl text-primary" />
          </div>
        ) : (
          <div className="text-gray-700">
            {content ? (
              <ReactMarkdown
                components={{
                  h1: ({node, ...props}) => <h1 className="text-3xl font-bold text-gray-900 mt-8 mb-4" {...props}>{props.children}</h1>,
                  h2: ({node, ...props}) => <h2 className="text-2xl font-bold text-gray-800 mt-6 mb-3" {...props}>{props.children}</h2>,
                  h3: ({node, ...props}) => <h3 className="text-xl font-bold text-gray-800 mt-5 mb-2" {...props}>{props.children}</h3>,
                  // Added text-justify here
                  p: ({node, ...props}) => <p className="mb-4 leading-relaxed text-justify" {...props}>{props.children}</p>,
                  ul: ({node, ...props}) => <ul className="list-disc list-inside mb-4 pl-4" {...props}>{props.children}</ul>,
                  ol: ({node, ...props}) => <ol className="list-decimal list-inside mb-4 pl-4" {...props}>{props.children}</ol>,
                  li: ({node, ...props}) => <li className="mb-2 text-justify" {...props}>{props.children}</li>,
                  strong: ({node, ...props}) => <strong className="font-bold text-gray-900" {...props}>{props.children}</strong>,
                  a: ({node, ...props}) => <a className="text-primary hover:underline" {...props}>{props.children}</a>,
                }}
              >
                {content}
              </ReactMarkdown>
            ) : (
              <p className="text-center text-gray-500 italic">Privacy Policy content not available.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;